import React from 'react'
import useIsMobile from 'hooks/useIsMobile'

import {
  Swiper,
  SwiperSlide,
} from 'swiper/react'

import { Navigation } from 'swiper'

import RecipeCard from '@/molecules/Card/Cards/RecipeCard'
import WithDecorationButton from '@/molecules/Buttons/WithDecorationButton'

import {
  StyledMosaicRecipe,
  StyledMosaicRecipeWrapper,
  StyledMosaicRecipeCta,
  StyledMosaicRecipeCols,
  StyledMosaicRecipeNavigation,
  StyledMosaicRecipeNavigationButton,
  StyledMosaicRecipeSlider
} from './styles'
import Icon from '@/atoms/Icon'

const MosaicRecipe = ({
  list,
  columnList,
  cta
}) => {
  const isMobile = useIsMobile()
  const sliderProps = {
    spaceBetween: 24,
    slidesOffsetBefore: 24,
    slidesOffsetAfter: 24,
    slidesPerView: 'auto',
    navigation: {
      nextEl: '.slider-button-next',
      prevEl: '.slider-button-prev',
    },
  }

  return (
    <StyledMosaicRecipe>
      {
        list &&
        list.length &&
        <StyledMosaicRecipeWrapper>
          {
            !isMobile
              ? (
                columnList.map((col, cIdx) => (
                  !!col.length &&
                  <StyledMosaicRecipeCols key={cIdx}>
                    {col.map(item=> <RecipeCard key={item.id} item={item} imageRatio={1} />)}
                  </StyledMosaicRecipeCols>
                ))
              )
              : (
                <StyledMosaicRecipeSlider>
                  <Swiper
                    {...sliderProps}
                    modules={[Navigation]}
                    role="region"
                    aria-label="Slider di contenuti"
                    aria-roledescription="carousel"
                  >
                    {
                      list.map((item, i) => (
                        <SwiperSlide key={i}>
                          <RecipeCard key={item.id} item={item} imageRatio={1} />
                        </SwiperSlide>
                      ))
                    }

                    <StyledMosaicRecipeNavigation aria-label="Controlli slider">
                      <StyledMosaicRecipeNavigationButton
                        className='slider-button-prev'
                        aria-label="Vai al contenuto precedente"
                        type="button"
                      >
                        <Icon name='chevron-left' aria-hidden='true' />
                      </StyledMosaicRecipeNavigationButton>
                      <StyledMosaicRecipeNavigationButton
                        className='slider-button-next'
                        aria-label="Vai al contenuto successivo"
                        type="button"
                      >
                        <Icon name='chevron-right' aria-hidden='true' />
                      </StyledMosaicRecipeNavigationButton>
                    </StyledMosaicRecipeNavigation>
                  </Swiper>
                </StyledMosaicRecipeSlider>
              )
          }
        </StyledMosaicRecipeWrapper>
      }
      {
        !!cta.link &&
        <StyledMosaicRecipeCta>
          <WithDecorationButton keyword={cta.keyword} href={cta.link.href} label={cta.link.title} />
        </StyledMosaicRecipeCta>
      }

    </StyledMosaicRecipe>
  )
}

export default MosaicRecipe
